export const READ_PARTNER_ONBOARDINGS = 'READ_PARTNER_ONBOARDINGS';
export const CREATE_PARTNER_ONBOARDING = 'CREATE_PARTNER_ONBOARDING';
export const UPDATE_PARTNER_ONBOARDING = 'UPDATE_PARTNER_ONBOARDING';
export const DELETE_PARTNER_ONBOARDING = 'DELETE_PARTNER_ONBOARDING';

export const readPartnerOnboardingsAction = (
  items,
  queryId = 'default',
) => ({
  type: READ_PARTNER_ONBOARDINGS,
  payload: { partnerOnboardings: items, queryId },
});

export const createPartnerOnboardingAction = (
  partnerOnboarding,
  queryId = 'default',
) => ({
  type: CREATE_PARTNER_ONBOARDING,
  payload: { partnerOnboarding, queryId },
});

export const updatePartnerOnboardingAction = (
  partnerOnboarding,
  queryId = 'default',
) => ({
  type: UPDATE_PARTNER_ONBOARDING,
  payload: { partnerOnboarding, queryId },
});

export const deletePartnerOnboardingAction = (
  partnerOnboardingId,
  queryId = 'default',
) => ({
  type: DELETE_PARTNER_ONBOARDING,
  payload: { partnerOnboardingId, queryId },
});

const initialState = { default: {} };

export function partnerOnboardings(state = initialState, action) {
  switch (action.type) {
    case READ_PARTNER_ONBOARDINGS: {
      const newState = {
        ...state,
        [action.payload.queryId]: { ...state[action.payload.queryId] },
      };
      action.payload.partnerOnboardings.forEach((p) => {
        newState[action.payload.queryId][p._id] = p;
      });
      return newState;
    }
    case CREATE_PARTNER_ONBOARDING:
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.partnerOnboarding._id]:
            action.payload.partnerOnboarding,
        },
      };
    case UPDATE_PARTNER_ONBOARDING: {
      const current =
        (state[action.payload.queryId] &&
          state[action.payload.queryId][
            action.payload.partnerOnboarding._id
          ]) ||
        undefined;
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.partnerOnboarding._id]: {
            ...current,
            ...action.payload.partnerOnboarding,
          },
        },
      };
    }
    case DELETE_PARTNER_ONBOARDING: {
      const { partnerOnboardingId } = action.payload;
      return Object.entries(state).reduce((prev, [key, val]) => {
        prev[key] = {
          ...val,
          [partnerOnboardingId]: undefined,
        };
        return prev;
      }, {});
    }
    default:
      return state;
  }
}
